// extracted by mini-css-extract-plugin
module.exports = {"listHeader":"InstructionTable_listHeader__11z9w","tableWrapper":"InstructionTable_tableWrapper___aFCZ"};